// extracted by mini-css-extract-plugin
export default {"container":"Products_container__-Lg7T","products":"Products_products__qJyWO","menu":"Products_menu__XTwnB","list":"Products_list__Fo+Sq","product":"Products_product__VKNyb"};